import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as common from '../../../../../common'

export const INPUT = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.mosaic.Page.Input,
    graphql.schema.MosaicPageForDevInput
  >({
    alias: transformers.PASS_THROUGH,
    content: graphql.transformers.IN.stringify(),
    description: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
    // NOTE: onNullish: 'preserve' is set because if we have null in query, we
    // don't want to remove/replace it because then we won't get correct data by
    // that query
    query: graphql.transformers.IN.stringify({ onNullish: 'preserve' }),
    variables: graphql.transformers.IN.list(
      common.gql.dms.data.inputs.variable.INPUT,
    ),
  }),
)

export const UPDATES = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.mosaic.Page.Updates,
    graphql.schema.MosaicPageForDevUpdates
  >({
    alias: transformers.PASS_THROUGH,
    content: graphql.transformers.IN.stringify(),
    description: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
    // NOTE: onNullish: 'preserve' is set because if we have null in query, we
    // don't want to remove/replace it because then we won't get correct data by
    // that query
    query: graphql.transformers.IN.stringify({ onNullish: 'preserve' }),
    variables: graphql.transformers.IN.list(
      common.gql.dms.data.inputs.variable.INPUT,
    ),
  }),
)
